
import { DataService } from '@/service/DataService';
import { getDataServerUrl } from '@/utils/functions';
import { Component, Vue } from 'vue-property-decorator';
import { DefaultDatePickerLangSettings } from '../../utils/constants';
import { LogRequest } from '@/utils/models';
import dayjs from 'dayjs';

@Component({})
export default class QuestionnaireView extends Vue {
  isLoading = false;
  logDateRange: Date[] = [];
  dataService: DataService | null = null;
  datePickerLang = DefaultDatePickerLangSettings;
  defaultValue: Date = new Date();
  disabledDate = (date: Date, currentValue: Date[]) => {
    return date.getTime() > Date.now();
  };

  private servUrl = getDataServerUrl();

  mounted() {
    this.dataService = this.$store.state.dataService;
  }

  onSubmit(event: Event) {
    event.preventDefault();
    this.questionnaireResultExport();
  }

  questionnaireResultExport() {
    this.isLoading = true;
    const from = this.logDateRange.length >= 2 ? this.logDateRange[0] : undefined;
    const to = this.logDateRange.length >= 2 ? dayjs(this.logDateRange[1]).add(24, 'hour').toDate() : undefined; //toの日付の分のアンケート結果も取得したいので24時間加算
    this.dataService?.emitGetQuestionnaireLog({ from, to }).then((path) => {
      this.isLoading = false;
      const url = this.servUrl + path.path;
      console.log('download questionnaire csv url', url);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = path.filename;
      a.href = url;
      a.click();
      a.remove();
    });
  }
}
